import {
  CommandBarButton,
  IDropdownOption,
  Stack,
  Text,
} from '@fluentui/react';
import {
  FormikCheckBox,
  FormikCountryRegion,
  FormikTextField,
} from 'common/components';
import React from 'react';
import { SupplierCommonData_countries_nodes } from '../../../__generated__/SupplierCommonData';
import { useStyles } from './index.styles';
interface AddressFormFieldsProps {
  addressName: string;
  toList: () => void;
  countries: SupplierCommonData_countries_nodes[];
  isUpdatable: boolean | null | undefined;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}
export const AddressFormFields: React.FC<AddressFormFieldsProps> = ({
  addressName,
  toList,
  countries,
  isUpdatable,
  setFieldValue,
}) => {
  const styles = useStyles();
  const countryOptions: IDropdownOption[] =
    countries.map((ele) => ({
      key: ele.id,
      text: ele.country,
    })) || [];
  const isDisabled = isUpdatable === false ? true : false;
  return (
    <>
      <Stack
        horizontal
        horizontalAlign="space-between"
        className={styles.defaultButtonContainer}
      >
        <CommandBarButton
          text="Address List"
          iconProps={{ iconName: 'Back' }}
          onClick={() => {
            toList();
          }}
          style={{
            width: 120,
            height: 40,
          }}
        />
      </Stack>
      <Text variant={'xLarge'}>Address</Text>
      <Stack
        horizontal
        tokens={{
          childrenGap: 20,
        }}
        className={styles.formRow}
      >
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.addressLine1`}
            label="Line 1)"
            placeholder="Street and Number, P.O. Box"
            disabled={isDisabled}
          />
        </Stack.Item>
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.addressLine2`}
            label="Line 2)"
            placeholder="Apartment, Suite, Unit, Building, Floor"
            disabled={isDisabled}
          />
        </Stack.Item>
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.cityName`}
            label="City"
            placeholder="City, Town"
            disabled={isDisabled}
          />
        </Stack.Item>
      </Stack>
      <Stack
        horizontal
        tokens={{
          childrenGap: 20,
        }}
        className={styles.formRow}
      >
        <Stack.Item style={{ flex: 2 }}>
          <FormikCountryRegion
            countries={countryOptions}
            countryName={`${addressName}.countryId`}
            regionName={`${addressName}.stateRegionId`}
            CountryAutocompleteProps={{
              label: 'Country',
              errorMessage: '',
            }}
            StateRegionAutocompleteProps={{
              label: 'State / Region / Province',
              errorMessage: '',
            }}
            onSelectCountry={(country) =>
              setFieldValue(`${addressName}.country.country`, country)
            }
            onSelectState={(state) =>
              setFieldValue(`${addressName}.stateRegion.stateRegion`, state)
            }
            disabled={isDisabled}
          />
        </Stack.Item>
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.postalCode`}
            label="Zip/Postal Code"
            placeholder="Zip/Postal Code"
            disabled={isDisabled}
          />
        </Stack.Item>
      </Stack>
      <Stack
        horizontal
        tokens={{
          childrenGap: 20,
        }}
        className={styles.formRow}
      >
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.telephoneNumber`}
            label="Phone"
            placeholder="Phone"
            disabled={isDisabled}
          />
        </Stack.Item>
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.emailAddress`}
            label="Email"
            placeholder="Email"
            disabled={isDisabled}
          />
        </Stack.Item>
        <Stack horizontal verticalAlign="end" className={styles.fieldContainer}>
          <Stack.Item className={styles.sendCheckBoxContainer}>
            <FormikCheckBox
              name={`${addressName}.isSendEmailAccount`}
              label="Send"
              disabled={isDisabled}
            />
          </Stack.Item>
          <Stack.Item>
            <FormikCheckBox
              name={`${addressName}.isReceiveEmailAccount`}
              label="Receive"
              disabled={isDisabled}
            />
          </Stack.Item>
        </Stack>
      </Stack>
      <Stack horizontal className={styles.formRow}>
        <Stack.Item className={styles.websiteFieldContainer}>
          <FormikTextField
            name={`${addressName}.webAddress`}
            label="Website"
            placeholder="Website"
            disabled={isDisabled}
          />
        </Stack.Item>
      </Stack>
    </>
  );
};
